import toast from "react-hot-toast";
import { customDateFormatType } from "../../utils/utils";

const { clientAPI } = require("../client");
export const lockingCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/locking", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/locking/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateIsWrongInput: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/updateIsWrongInput/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  get: async (id) => {
    try {
      const response = await clientAPI("get", `/locking/${id}`);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approve: async (id, data) => {
    try {
      const response = await clientAPI("put", `/locking/approve/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approveRegisterRelative: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/approveRegisterRelative/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getCalculateCommission: async (id, period) => {
    try {
      const response = await clientAPI(
        "get",
        `/locking/calculateCommission/${id}/${period}`,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getEstimateCommission: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/locking/estimateCommission/${id}`,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approveCalculateCommission: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/approveCalculateCommission/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approveCommission: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/approveCommission/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approveInformation: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/approveInformation/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  revert: async (id, data) => {
    try {
      const response = await clientAPI("put", `/locking/revert/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  confirmCommission: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/confirmCommission/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateHiddenStatus: async (id) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/updateHiddenStatus/${id}`,
      );
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  refund: async (id, data) => {
    try {
      const response = await clientAPI("put", `/locking/refund/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  bulkAdd: async (data) => {
    try {
      const response = await clientAPI("post", "/locking/bulk/", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  bulkImport: async (data) => {
    try {
      const response = await clientAPI("post", "/locking/bulkImport/", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateConfirm: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/updateConfirm/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("updateConfirm error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  transfer: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/app/transfer/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("transfer error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approveRegisterRelativeMany: async (data) => {
    try {
      const response = await clientAPI(
        "post",
        "/locking/approveRegisterRelativeMany",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approveInformationMany: async (data) => {
    try {
      const response = await clientAPI(
        "post",
        "/locking/approveInformationMany",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getPeriodFeeCompensation: async (id, idSaleOpenEvent, period) => {
    try {
      const response = await clientAPI(
        "get",
        `/locking/getPeriodFeeCompensation/${id}?saleOpeningEventMechanismParametersId=${idSaleOpenEvent}&period=${period}`,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getTypeImage: async (id) => {
    try {
      const response = await clientAPI("get", `/locking/getTypeImage/${id}`);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  downloadPDF: async (id, payload) => {
    try {
      const response = await clientAPI(
        "put",
        `/locking/downloadPDF/${id}`,
        payload,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (param) => {
    try {
      const options = {};

      if (param?.search !== undefined) options.search = param?.search;
      if (param?.projectId?.length) options.projectId = param?.projectId;
      if (param?.bookerId) options.bookerId = param?.bookerId;
      if (param?.lockingEventId) options.lockingEventId = param?.lockingEventId;
      if (param?.status?.length) options.status = param?.status;
      if (param?.isTtkqHdmbs) options.isTtkqHdmbs = param?.isTtkqHdmbs;
      if (param?.apartmentId?.length) options.apartmentId = param?.apartmentId;
      if (param?.customerId) options.customerId = param?.customerId;
      if (param?.startTime)
        options.startTime = customDateFormatType(param?.startTime);
      if (param?.endTime)
        options.endTime = customDateFormatType(param?.endTime);
      if (param?.saleBlockId) options.saleBlockId = param?.saleBlockId;
      if (param?.saleAreaId) options.saleAreaId = param?.saleAreaId;
      if (param?.startTimeCreated)
        options.startTimeCreated = customDateFormatType(
          param?.startTimeCreated,
        );
      if (param?.endTimeCreated)
        options.endTimeCreated = customDateFormatType(param?.endTimeCreated);
      if (param?.inputLate) options.inputLate = param?.inputLate;

      const queryParams = new URLSearchParams(options).toString();

      const response = await clientAPI("get", `/locking/export?${queryParams}`);

      const dataExport = response?.exportData;

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
